export default "__VITE_ASSET__C2Xwn8CS__"